<template>
  <div>
    <div class="col-md-12">
      <div class="form-row form_padrao">
        <div class="form-group flutuante col-md-12 position-relative rounded">
          <input
            type="text"
            name="pesquisar"
            id="pesquisar"
            v-model="filters['global'].value"
          />
          <label for="pesquisar">Filtrar</label>
        </div>
      </div>
    </div>

    <div class="col-12 mb-4">
      <DataTable
        class="p-datatable-sm"
        dataKey="id"
        :filters="filters"
        ref="dt"
        :paginator="true"
        :rows="10"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="Exibindo {first} até {last} de {totalRecords}"
        selectionMode="single"
        :value="lista"
        data-key="id"
      >
        <template #empty>
          Você ainda não possui associados em sua carteira.
        </template>
        <template #loading> Carregando... </template>
        <Column
          field="codSocio"
          header="Código do Sócio"
          :style="{ width: '90px' }"
          frozen
          sortable
        ></Column>
        <Column
          field="nomeSocio"
          header="Nome do Sócio / Email"
          sortable
        ></Column>
        <Column field="documento" header="CPF" sortable>
          <template #body="slotProps">
            {{ slotProps.data.documento | formataCPF }}
          </template>
        </Column>
        <Column field="etapa" header="Etapa" sortable></Column>
        <Column field="action" header="" sortable>
          <template #body="slotProps">
            <div
              v-if="slotProps.data.router && slotProps.data.codSocio != '-'"
              class="link"
              :class="slotProps.data.color"
              v-on:click="
                selecionarAssociado(
                  slotProps.data.codSocio,
                  slotProps.data.router
                )
              "
            >
              <span class="d-md-flex action">{{ slotProps.data.action }}</span>
            </div>
            <div
              v-else-if="
                slotProps.data.router && slotProps.data.codSocio == '-'
              "
              class="link"
              :class="slotProps.data.color"
              v-on:click="
                selecionarAssociado(slotProps.data.email, slotProps.data.router)
              "
            >
              <span class="action">{{ slotProps.data.action }}</span>
            </div>
            <span v-else class="d-md-flex"> {{ slotProps.data.action }}</span>
          </template>
        </Column>
        <Column field="email" header="Enviar Login">
          <template #body="slotProps">
            <span class="d-md-flex action">
              <Botao
                title="Enviar Login"
                :class="{ disabled: slotProps.data.codSocio == '-' }"
                @click="
                  slotProps.data.codSocio != '-'
                    ? enviarLogin(slotProps.data.codSocio, slotProps.index)
                    : ''
                "
                nameClass="btn btn-success btn-sm font-weight-bold"
                :disabled="{ disabled: slotProps.data.codSocio == '-' }"
              >
                <span
                  class="spinner-grow spinner-grow-sm pr-2 mr-1"
                  role="status"
                  aria-hidden="true"
                  v-show="rowSel == slotProps.index && loading"
                ></span>
                <span v-if="rowSel == slotProps.index && loading"
                  >Enviando...</span
                >
                <span v-else>Enviar Login</span>
              </Botao>
            </span>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>
<script>
import DataTable from "primevue/datatable";
import Botao from "@/components/botoes/Botao";
import Column from "primevue/column";
export default {
  name: "Lista",
  components: { DataTable, Column, Botao },
  props: {
    lista: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      usuarioCpf: null,
      desc: null,
      loading: false,
      etapa: "",
      filters: {
        global: { value: null },
      },
      rowSel: null,
    };
  },
  filters: {
    formataCPF(cpf) {
      //retira os caracteres indesejados...
      cpf = cpf.replace(/[^\d]/g, "");

      //realizar a formatação...
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    formataData(dataObj) {
      const data = new Date(dataObj);
      const dataStr =
        ("0" + data.getDate()).slice(-2) +
        "/" +
        ("0" + (data.getMonth() + 1)).slice(-2) +
        "/" +
        data.getFullYear();
      return dataStr;
    },
  },
  methods: {
    selecionarAssociado(id, action) {
      localStorage.setItem("associadoSelecionado", id);
      if (action === "cadastro") {
        this.$router.push({ name: "filiacao" });
      } else if (action === "arquivos") {
        this.$router.push({ name: "consultorArquivos" });
      } else if (action === "editar") {
        this.$router.push({ name: "filiacao" });
      } else if (action === "chamados") {
        this.$router.push({ name: "filiacao" });
      } else if (action === "resetSenha") {
        this.$router.push({ name: "filiacao" });
      } else if (action === "painelAssociado") {
        this.$router.push({ name: "painelAssociado" });
      }
    },
    enviarLogin(id, index) {
      if (id) {
        this.loading = true;
        this.rowSel = index;

        this.$http
          .post(`/api/Consultor/EnviarEmailCredenciaisAssociado?codSocio=${id}`)
          .then((response) => {
            this.loading = false;
            this.$toast.open({
              message: response.data.mensagem,
              type: "success",
              duration: 6000,
            });
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$router.push({ name: "login" });
            }
            this.$toast.open({
              message: "Erro ao enviar o login do associado, tente novamente.",
              type: "error",
            });
            this.loading = false;
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 1.4;
}
.value {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
.simple-value {
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
.action {
  font-weight: bold !important;
}
</style>
